import ProductAttributes from './ProductAttributes';
export default ProductAttributes;
